/** 1 is new value is greater than old value, -1 if old value is greater than new value, 0 if equal. */
export function getIndicator(oldValue: number, newValue: number) {
    if (newValue > oldValue) return 1;
    if (newValue < oldValue) return -1;
    return 0;
}